import React from "react"
import { Image } from "react-bootstrap"
import { classNames } from "../../../../helpers/classNames"

// type guideImage = {
//   list: Boolean,
//   preview: Boolean
//   full: Boolean
//   data: {
//         url: String
//         caption: { en: String, fi: String },
//         thumbnail: String,
//         imageFileId: String
//       },
// }

export const GuideImage = ({ data, list, preview, full }) => {
  const classes = classNames({
    "image-container": true,
    list: list,
    preview: preview,
    fullsize: full
  })

  return (
    <div className={classes}>
      <Image src={data?.url} />
    </div>
  )
}
